import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import HealthcareIcon from "@mui/icons-material/LocalHospital";
import ThreeIcon from "@mui/icons-material/Looks3";
import OneIcon from "@mui/icons-material/LooksOne";
import TwoIcon from "@mui/icons-material/LooksTwo";
import PaidIcon from "@mui/icons-material/Paid";
import ContactIcon from "@mui/icons-material/PhoneCallback";
import ReportGmailerrorredRoundedIcon from "@mui/icons-material/ReportGmailerrorredRounded";
import UsedIcon from "@mui/icons-material/SyncProblem";
import SearchingIcon from "@mui/icons-material/Troubleshoot";
import TreatmentIcon from "@mui/icons-material/Vaccines";
import HandshakeIcon from "@mui/icons-material/VolunteerActivism";
import { Backdrop, Box, Button, Grid } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { darken, lighten, useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import gtag from "ga-gtag";
import { v4 as uuid } from "uuid";

import constants from "../../assets/constants";
import * as OnboardingSessionActions from "../../state/redux/onboardingSession";
import { deepCopyObject } from "../../utils/helpers";
import AssessmentWizardDialog from "../dialogs/assessmentWizardDialog";
import OmniSpinner from "../ui/omniSpinner";
import Widget from "../ui/widget";
import WidgetContent from "../ui/widgetContent";
import WidgetFooter from "../ui/widgetFooter";
import WidgetTitle from "../ui/widgetTitle";

const UserOnboardAssessment = props => {
  const {
    onboardingODM,
    organizationODM,
    onboardingStatus,
    inviteKey,
    assessmentODM,
    onboardingProctorODM,
    onboardingSubjectODM,
    onboardingAssessmentType,
    userODM,
  } = props;

  const [localOnboardingODM, setLocalOnboardingODM] = useState(null);
  const [dialogTitle, setDialogTitle] = useState(null);

  const [showAssessmentDialog, setShowAssessmentDialog] = useState(null);

  const [sendingRequest, setSendingRequest] = useState(false);

  const smallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const theme = useTheme();

  useEffect(() => {
    if (onboardingODM != null) {
      //TODO add a shit ton of error handling try/catch
      let newODM = deepCopyObject(onboardingODM);
      if (newODM.omniData.inviteType === constants.inviteType.shared) {
        newODM.omniData.userData.familyName = "";
        newODM.omniData.userData.givenName = "";
        newODM.omniData.userData.displayName = "";
        newODM.omniData.userData.mobilePhone = "";
        newODM.omniData.userData.email = "";
      }
      setLocalOnboardingODM(newODM);
    } else {
      // //use the default "user Info for now, but this should really clear the data
      // //TODO make the redux sate load a fake one from above

      setLocalOnboardingODM(null);
    }
  }, [onboardingODM]);

  const [bannerImage, setBannerImage] = useState(null);
  const [postAssessmentHTML, setPostAssessmentHTML] = useState(null);
  const [onboardingHTML, setOnboardingHTML] = useState(null);

  useEffect(() => {
    if (organizationODM != null) {
      setDialogTitle(
        organizationODM.omniData.organizationType === constants.organizationTypeEnums.empireOS
          ? "Create Your Empire"
          : "Health Assessment Guide",
      );
      if (organizationODM.omniData.onboardingBanner) {
        setBannerImage(organizationODM.omniData.onboardingBanner);
      }
      if (organizationODM.omniData.onboardingHTML) {
        setOnboardingHTML(organizationODM.omniData.onboardingHTML);
      } else if (onboardingODM !== null && onboardingODM.omniData.onboardingHTML !== null) {
        setOnboardingHTML(onboardingODM.omniData.onboardingHTML);
      }

      if (organizationODM.omniData.postAssessmentHTML) {
        setPostAssessmentHTML(organizationODM.omniData.postAssessmentHTML);
      } else if (onboardingODM !== null && onboardingODM.omniData.postAssessmentHTML !== null) {
        setPostAssessmentHTML(onboardingODM.omniData.postAssessmentHTML);
      }
    }
  }, [organizationODM, onboardingODM]);

  const defaultRedrectTimeout = 5;
  const [redirectTimer, setRedirectTimer] = useState(defaultRedrectTimeout);

  useEffect(() => {
    if (redirectTimer === 0 && !userODM) {
      //Redirect to Login
      // var originURL = window..locationorigin;
      // window.location.href = `${originURL}/`;
    }
  }, [redirectTimer, userODM]);

  useEffect(() => {
    if (sendingRequest && userODM) {
      setSendingRequest(false);
    } else if (
      !sendingRequest &&
      userODM &&
      organizationODM.omniData.organizationType !== constants.organizationTypeEnums.omnisicaHealth
    ) {
      //Redirect to Login
      var originURL = window.location.origin;
      window.location.href = `${originURL}/`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendingRequest, setSendingRequest, userODM]);

  useEffect(() => {
    if (onboardingStatus != null) {
      // Think we'd rather have a catch all gtag here for the time being
      // instead of
      if (onboardingStatus.errorCode) {
        gtag("event", "omni_onboarding_error", {
          errorCode: `${onboardingStatus.errorCode}`,
          errorText: `${onboardingStatus.errorText}`,
        });
      }

      if (onboardingStatus.errorCode === 400 && onboardingStatus.errorText.includes("completed")) {
        setTimeout(() => {
          setRedirectTimer(prevTimer => (prevTimer === 0 ? defaultRedrectTimeout : prevTimer - 1));
        }, 1000);
      } else if (onboardingStatus.errorCode === 400) {
        //this probably will never happen? find!ak
      }
    }
  }, [onboardingStatus, redirectTimer, setRedirectTimer, userODM]);

  const onboardUserHandler = () => {
    //this is only called from below, and is guarded
    setSendingRequest(true);

    let finalOnboardingODM = deepCopyObject(localOnboardingODM);

    // this shit is a proxy so we could move over the stuff below
    finalOnboardingODM.omniData.userData.displayName = onboardingProctorODM.omniData.displayName;
    finalOnboardingODM.omniData.userData.givenName = onboardingProctorODM.omniData.givenName;
    finalOnboardingODM.omniData.userData.familyName = onboardingProctorODM.omniData.familyName;

    if (onboardingSubjectODM.omniData.hasOwnProperty("businessPillar")) {
      //special case where we are updating the onboaring userData
      //Because they might have disclosed addtional items nboarding
      finalOnboardingODM.omniData.userData.businessPillar =
        onboardingSubjectODM.omniData.businessPillar;
    }

    if (
      onboardingSubjectODM.omniData.hasOwnProperty("isProxyPatient") &&
      onboardingSubjectODM.omniData.isProxyPatient
    ) {
      //special case where we are updating the onboaring userData
      //Because they might have disclosed addtional items nboarding
      finalOnboardingODM.omniData.userData.birthdate = onboardingSubjectODM.omniData.birthdate;
      finalOnboardingODM.omniData.userData.gender = onboardingSubjectODM.omniData.gender;
      finalOnboardingODM.omniData.userData.race = onboardingSubjectODM.omniData.race;
      finalOnboardingODM.omniData.userData.ethnicity = onboardingSubjectODM.omniData.ethnicity;
      finalOnboardingODM.omniData.userData.email = onboardingSubjectODM.omniData.email;
      finalOnboardingODM.omniData.userData.mobilePhone = onboardingSubjectODM.omniData.mobilePhone;
    }

    //TODO check for changed email and phone?

    finalOnboardingODM.omniData["credentials"] = {
      password: `${uuid()}mak3Val1d!`,
      username: `${finalOnboardingODM.omniData.userData.givenName
        .trim()
        .replace(/\W/g, "")}${finalOnboardingODM.omniData.userData.familyName
        .trim()
        .replace(/\W/g, "")}${Math.floor(Math.random() * 1000000)}`,
    };

    gtag("event", "omni_onboarding_complete", {
      invite_key: inviteKey,
    });

    props.onboardUserRequest({
      onboardingODM: finalOnboardingODM,
      assessmentODM: assessmentODM,
      onboardingProctorODM: onboardingProctorODM,
      onboardingSubjectODM: onboardingSubjectODM,
      passiveOnboard: false,
    });
  };

  useEffect(() => {
    if (onboardingProctorODM != null && assessmentODM != null && onboardingSubjectODM != null) {
      onboardUserHandler();
    }

    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentODM, onboardingProctorODM, onboardingSubjectODM]);

  // We need to make sure the dialog
  // goes away if the user quits the assessment
  // or they're all done with the assessment
  // or it's not a valid invitation
  const [runAutoLaunchTimer, setRunAutoLaunchTimer] = useState(false);

  useEffect(() => {
    if (userODM || localOnboardingODM == null) {
      setRunAutoLaunchTimer(false);
    } else {
      // setRunAutoLaunchTimer(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setRunAutoLaunchTimer, userODM, localOnboardingODM]);

  // Auto timer duration & functionality
  const [autoLaunchTimer, setAutoLaunchTimer] = useState(100);

  useEffect(() => {
    // We need to run the timer
    if (autoLaunchTimer > 0 && runAutoLaunchTimer) {
      setTimeout(() => setAutoLaunchTimer(autoLaunchTimer - 1), 100);
    } else if (autoLaunchTimer === 0 && runAutoLaunchTimer) {
      // We've hit zero on the countdown show the
      // assessment dialog and don't restart the timer
      gtag("event", "omni_onboarding_timer_expired", {
        invite_key: `${inviteKey}`,
      });
      setShowAssessmentDialog(true);
      setRunAutoLaunchTimer(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoLaunchTimer, runAutoLaunchTimer, inviteKey]);

  const mobileLayout = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Widget widgetSize="large" allowShrink={false}>
      {!bannerImage && <WidgetTitle title={"Welcome"}></WidgetTitle>}
      {bannerImage && <Box>{bannerImage}</Box>}

      {/*user exists - show post onboarding or guard testers*/}
      {userODM &&
        !sendingRequest &&
        organizationODM.omniData.organizationType ===
          constants.organizationTypeEnums.omnisicaHealth && (
          <WidgetContent noMargins={true} footer={true}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                padding: theme.spacing(2),
                paddingRight: theme.spacing(1),
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",

                  overflowY: "auto",
                  "&::-webkit-scrollbar": {
                    width: theme.spacing(2),
                    borderRadius: theme.spacing(1),
                  },
                  "&:hover::-webkit-scrollbar": {
                    width: theme.spacing(2),
                  },
                  "&::-webkit-scrollbar-track": {
                    borderRadius: theme.spacing(1),
                    backgroundColor: darken(theme.palette.commonground.main, 0.4),
                    backgroundClip: "content-box",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    opacity: "0.5",
                    borderRadius: theme.spacing(1),
                    backgroundColor: theme.palette.secondary.main,
                  },
                  "&:hover::-webkit-scrollbar-thumb": {
                    backgroundColor: lighten(theme.palette.secondary.main, 0.2),
                  },
                }}
              >
                {/* default message */}
                {!postAssessmentHTML && (
                  <Grid container justifyContent={"center"}>
                    <Grid
                      container
                      xs={12}
                      spacing={1}
                      alignContent={"center"}
                      justifyContent={"center"}
                    >
                      <Grid xs={12}>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                          }}
                        >
                          <Typography variant={"h4"} sx={{ fontWeight: "bold" }}>
                            You're all done! What now?
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid xs={12}>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            marginTop: theme.spacing(2),
                          }}
                        >
                          <SearchingIcon color="primary" fontSize="large" />
                          <Typography
                            variant={"h5"}
                            sx={{ marginTop: theme.spacing(0.25), marginLeft: theme.spacing(1) }}
                          >
                            Relax while we check your results
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid xs={12} alignItems={"center"}>
                        <Typography variant={"body1"} sx={{ textAlign: "center" }}>
                          We check our network for the best matches to your health profile.
                        </Typography>
                      </Grid>

                      <Grid xs={12}>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            marginTop: theme.spacing(2),
                          }}
                        >
                          <ContactIcon color="primary" fontSize="large" />
                          <Typography
                            variant={"h5"}
                            sx={{ marginTop: theme.spacing(0.25), marginLeft: theme.spacing(1) }}
                          >
                            Keep an eye on your phone
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid xs={12} alignItems={"center"}>
                        <Typography variant={"body1"} sx={{ textAlign: "center" }}>
                          We will contact you and share the results.
                        </Typography>
                      </Grid>

                      <Grid xs={12}>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            marginTop: theme.spacing(2),
                          }}
                        >
                          <HandshakeIcon color="primary" fontSize="large" />
                          <Typography
                            variant={"h5"}
                            sx={{
                              marginTop: theme.spacing(0.25),
                              marginLeft: theme.spacing(1),
                            }}
                          >
                            Share with Others
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid xs={12} alignItems={"center"}>
                        <Typography
                          variant={"body1"}
                          sx={{ textAlign: "center", marginBottom: theme.spacing(1) }}
                        >
                          Let your friends and family know about this free service
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {postAssessmentHTML && (
                  <iframe
                    src={postAssessmentHTML}
                    frameBorder="0"
                    height={"100%"}
                    title="Special Onboarding Message"
                  />
                )}
              </Box>

              <Button
                variant={"contained"}
                sx={[
                  mobileLayout && { boxShadow: theme.shadows[3] },
                  {
                    boxShadow: theme.shadows[3],
                    marginLeft: theme.spacing(4),
                    marginRight: theme.spacing(4),
                    padding: theme.spacing(3),
                    display: "flex",
                    alignSelf: "center",
                    width: "calc(100% - 64px)",
                    borderRadius: theme.spacing(2),
                    marginTop: theme.spacing(1),
                  },
                ]}
                onClick={e => {
                  e.stopPropagation();
                  gtag("event", "omni_onboarding_navigate_to_portal_click", {
                    invite_key: `${inviteKey}`,
                  });

                  var originURL = window.location.origin;
                  window.location.href = `${originURL}/`;
                }}
              >
                <Typography variant="h4">{"Show me more"}</Typography>
              </Button>
            </Box>

            <WidgetFooter />
          </WidgetContent>
        )}

      {/*no user */}
      {!userODM && (
        <WidgetContent noMargins={true} footer={true}>
          {/* waiting to load the onboarding */}
          {localOnboardingODM == null && (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                position: "relative",
                padding: theme.spacing(4),
                paddingTop: theme.spacing(2),
                paddingBottom: "0",
                userSelect: "none",
              }}
            >
              <Grid
                container
                spacing={1}
                direction="row"
                justifyContent="flex-start"
                alignItems={"stretch"}
              >
                <Grid xs={12}>
                  <Typography
                    variant={"h5"}
                    sx={{
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    {!onboardingStatus
                      ? "Looking for your invitation"
                      : onboardingStatus.errorCode === 404
                        ? `${onboardingStatus.errorText}`
                        : `${onboardingStatus.errorCode} - ${onboardingStatus.errorText}`}
                  </Typography>
                </Grid>
                <Grid xs={12}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                    }}
                  >
                    {onboardingStatus ? (
                      <ReportGmailerrorredRoundedIcon
                        sx={{
                          width: "220px",
                          height: "220px",
                          textAlign: "center",
                          color: theme.palette.secondary.main,
                        }}
                      />
                    ) : (
                      <OmniSpinner size={237} fillcolor={theme.palette.secondary.main} />
                    )}
                  </Box>
                </Grid>
                <Grid xs={12}>
                  <Typography
                    variant={"h4"}
                    sx={{
                      width: "100%",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    {!onboardingStatus
                      ? "( Please be patient )"
                      : onboardingStatus.errorCode === 404
                        ? "We can't find your invitation"
                        : `${onboardingStatus.errorCode} - ${onboardingStatus.errorText}`}
                  </Typography>
                  <Grid xs={12}>
                    <Typography
                      variant={"h5"}
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        marginTop: theme.spacing(0.5),
                      }}
                    >
                      {!onboardingStatus
                        ? " "
                        : onboardingStatus.errorCode === 404
                          ? "You can request another another one on our website"
                          : `${onboardingStatus.errorCode} - ${onboardingStatus.errorText}`}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Button
                variant={"contained"}
                sx={[
                  mobileLayout && { boxShadow: theme.shadows[3] },
                  {
                    boxShadow: theme.shadows[3],
                    marginLeft: theme.spacing(4),
                    marginRight: theme.spacing(4),
                    padding: theme.spacing(3),
                    display: "flex",
                    alignSelf: "center",
                    width: "calc(100% - 64px)",
                    borderRadius: theme.spacing(2),
                    position: "absolute",
                    bottom: theme.spacing(2),
                    marginTop: theme.spacing(1),
                  },
                  !onboardingStatus && {
                    visibility: "hidden",
                  },
                ]}
                onClick={e => {
                  e.stopPropagation();
                  gtag("event", "omni_onboarding_navigate_to_contactus_click", {
                    invite_key: `${inviteKey}`,
                  });
                  window.location.replace("https://www.omnisciahealth.com/contact-us");
                }}
              >
                <Typography variant="h4">{"Request Invitation"}</Typography>
              </Button>
            </Box>
          )}

          {/*sad path */}
          {localOnboardingODM != null &&
            (!localOnboardingODM.omniAudit.isActive ||
              localOnboardingODM.omniData.invitationStatus !== "created") && (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  padding: theme.spacing(4),
                  paddingTop: theme.spacing(2),
                  paddingBottom: "122px",
                  userSelect: "none",
                }}
              >
                <Grid
                  container
                  spacing={1}
                  direction="row"
                  justifyContent="flex-start"
                  alignItems={"stretch"}
                >
                  <Grid xs={12}>
                    <Typography
                      variant={"h5"}
                      sx={{
                        width: "100%",
                        // fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Sorry, this invitation is no longer valid.
                    </Typography>
                  </Grid>
                  <Grid xs={12}>
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <UsedIcon
                        sx={{
                          width: "220px",
                          height: "220px",
                          textAlign: "center",
                          color: theme.palette.secondary.main,
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid xs={12}>
                    <Typography
                      variant={"h4"}
                      sx={{
                        width: "100%",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Don't worry, we have an invitation for you.
                    </Typography>
                    <Grid xs={12}>
                      <Typography
                        variant={"h5"}
                        sx={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: theme.spacing(0.5),
                        }}
                      >
                        Just click the button below to get started.
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Button
                  variant={"contained"}
                  sx={[
                    mobileLayout && { boxShadow: theme.shadows[3] },
                    {
                      boxShadow: theme.shadows[3],
                      marginLeft: theme.spacing(4),
                      marginRight: theme.spacing(4),
                      padding: theme.spacing(3),
                      display: "flex",
                      alignSelf: "center",
                      width: "calc(100% - 64px)",
                      borderRadius: theme.spacing(2),
                      position: "absolute",
                      bottom: theme.spacing(2),
                    },
                  ]}
                  disabled={!organizationODM.omniData.sharedInviteKey}
                  onClick={e => {
                    e.stopPropagation();
                    gtag("event", "omni_onboarding_navigate_to_default_invite_click", {
                      invite_key: `${inviteKey}`,
                    });

                    let onboardUrl = `${window.location.origin}/onboarding?inviteKey=${organizationODM.omniData.sharedInviteKey}`;
                    window.location.href = onboardUrl;
                  }}
                >
                  <Typography variant={smallScreen ? "h5" : "h4"}>{"Click to Start"}</Typography>
                </Button>
              </Box>
            )}

          {/*happy path onboarding */}
          {localOnboardingODM != null &&
            localOnboardingODM.omniAudit.isActive &&
            localOnboardingODM.omniData.invitationStatus === "created" && (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  padding: theme.spacing(2),
                  paddingRight: theme.spacing(1),
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",

                    overflowY: "auto",
                    "&::-webkit-scrollbar": {
                      width: theme.spacing(2),
                      borderRadius: theme.spacing(1),
                    },
                    "&:hover::-webkit-scrollbar": {
                      width: theme.spacing(2),
                    },
                    "&::-webkit-scrollbar-track": {
                      borderRadius: theme.spacing(1),
                      backgroundColor: darken(theme.palette.commonground.main, 0.4),
                      backgroundClip: "content-box",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      opacity: "0.5",
                      borderRadius: theme.spacing(1),
                      backgroundColor: theme.palette.secondary.main,
                    },
                    "&:hover::-webkit-scrollbar-thumb": {
                      backgroundColor: lighten(theme.palette.secondary.main, 0.2),
                    },
                  }}
                >
                  {/* default message */}
                  {!onboardingHTML && (
                    <Box
                      sx={{
                        width: "100%",
                        height: "calc(100% - 100px)",
                        display: "flex",
                        flexDirection: "column",
                        padding: 0,
                        margin: 0,
                        overflowY: "visible",
                      }}
                    >
                      <Grid
                        container
                        spacing={1}
                        direction="row"
                        justifyContent="flex-start"
                        alignItems={"stretch"}
                      >
                        <Grid xs={12}>
                          <Typography
                            variant={"h4"}
                            sx={{ fontWeight: "bold", marginBottom: theme.spacing(3) }}
                          >
                            Let us help you find the best clinical trial
                          </Typography>
                        </Grid>

                        <Grid
                          container
                          xs={12}
                          sm={5}
                          spacing={1}
                          alignContent={"top"}
                          justifyContent={"left"}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "left",
                              paddingBottom: 0,
                              marginLeft: theme.spacing(1),
                            }}
                          >
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "left",
                              }}
                            >
                              <Typography variant={"h4"}>Benefits</Typography>
                            </Box>
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "left",
                                marginTop: theme.spacing(1),
                              }}
                            >
                              <TreatmentIcon color="primary" fontSize="large" />
                              <Typography
                                variant={"h5"}
                                sx={{
                                  marginTop: theme.spacing(0.25),
                                  marginLeft: theme.spacing(1),
                                }}
                              >
                                New Treatments
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "left",
                                marginTop: theme.spacing(1),
                              }}
                            >
                              <HealthcareIcon color="primary" fontSize="large" />
                              <Typography
                                variant={"h5"}
                                sx={{
                                  marginTop: theme.spacing(0.25),
                                  marginLeft: theme.spacing(1),
                                }}
                              >
                                Free Healthcare
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "left",
                                marginTop: theme.spacing(1),
                                marginBottom: theme.spacing(2),
                              }}
                            >
                              <PaidIcon color="primary" fontSize="large" />
                              <Typography
                                variant={"h5"}
                                sx={{
                                  marginTop: theme.spacing(0.25),
                                  marginLeft: theme.spacing(1),
                                }}
                              >
                                Compensation
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid
                          container
                          xs={12}
                          sm={7}
                          spacing={1}
                          alignContent={"top"}
                          justifyContent={"left"}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "left",
                              paddingBottom: 0,
                              marginLeft: theme.spacing(1),
                            }}
                          >
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "left",
                              }}
                            >
                              <Typography variant={"h4"}>How it works</Typography>
                            </Box>
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "left",
                                marginTop: theme.spacing(1),
                              }}
                            >
                              <OneIcon color="primary" fontSize="large" />
                              <Typography
                                variant={"h5"}
                                sx={{
                                  marginTop: theme.spacing(0.25),
                                  marginLeft: theme.spacing(1),
                                }}
                              >
                                You build a health profile online
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "left",
                                marginTop: theme.spacing(1),
                              }}
                            >
                              <TwoIcon color="primary" fontSize="large" />
                              <Typography
                                variant={"h5"}
                                sx={{
                                  marginTop: theme.spacing(0.25),
                                  marginLeft: theme.spacing(1),
                                }}
                              >
                                We match you to research trials
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "left",
                                marginTop: theme.spacing(1),
                                marginBottom: theme.spacing(2),
                              }}
                            >
                              <ThreeIcon color="primary" fontSize="large" />
                              <Typography
                                variant={"h5"}
                                sx={{
                                  marginTop: theme.spacing(0.25),
                                  marginLeft: theme.spacing(1),
                                }}
                              >
                                Our team explains your options
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                  {onboardingHTML && (
                    <iframe
                      src={onboardingHTML}
                      frameBorder="0"
                      height={"100%"}
                      title="Special Onboarding Message"
                    />
                  )}
                </Box>

                <Button
                  variant={"contained"}
                  sx={[
                    mobileLayout && { boxShadow: theme.shadows[3] },
                    {
                      boxShadow: theme.shadows[3],
                      marginTop: theme.spacing(1),
                      padding: theme.spacing(2),
                      display: "flex",
                      alignSelf: "center",
                      width: "calc(100% - 64px)",
                      borderRadius: theme.spacing(2),
                    },
                  ]}
                  onClick={e => {
                    e.stopPropagation();
                    gtag("event", "omni_onboarding_start_click", {
                      invite_key: `${inviteKey}`,
                    });
                    setShowAssessmentDialog(true);
                  }}
                >
                  <Typography variant={smallScreen ? "h5" : "h4"}>{"Click to Start"}</Typography>
                  {/* {autoLaunchTimer > 0 && (
                  <Box
                    alignSelf={"flex-end"}
                    sx={{ height: "38px", marginRight: theme.spacing(3) }}
                  >
                    <Typography variant="overline">
                      {"Auto Start in "}
                      {Math.round(autoLaunchTimer / 10)}
                    </Typography>
                    <Switch
                      checked={runAutoLaunchTimer}
                      checkedIcon={
                        <PlayCircleIcon
                          sx={{
                            marginTop: "-2px",
                            color: theme.palette.primary.main,
                            background: `radial-gradient(circle, ${theme.palette.commonground.main} 0%,  ${theme.palette.commonground.main} 49%, ${theme.palette.primary.main} 50%)`,
                            borderRadius: "50%",
                            boxShadow: theme.shadows[3],
                          }}
                        />
                      }
                      icon={
                        <PauseCircleIcon
                          sx={{
                            marginTop: "-2px",
                            color: theme.palette.primary.main,
                            background: `radial-gradient(circle, ${theme.palette.commonground.main} 0%,  ${theme.palette.commonground.main} 49%, ${theme.palette.primary.main} 50%)`,
                            borderRadius: "50%",
                            boxShadow: theme.shadows[3],
                          }}
                        />
                      }
                      onChange={() => {
                        setRunAutoLaunchTimer(val => !val);
                      }}
                    />
                  </Box>
                )} */}
                </Button>

                {sendingRequest && !userODM && (
                  <Backdrop
                    sx={{
                      color: "#fff",
                      backgroundColor: "rgba(0,0,0,0.8)",
                      zIndex: theme => theme.zIndex.drawer + 1,
                    }}
                    open={!userODM}
                  >
                    <Grid
                      container
                      direction={"column"}
                      justifyContent={"center"}
                      alignContent={"center"}
                    >
                      <Grid>
                        <Typography variant="h6">Please wait</Typography>
                      </Grid>
                      <Grid container xs={12} justifyContent={"center"} alignContent={"center"}>
                        <Grid>
                          <OmniSpinner size="150" />
                        </Grid>
                      </Grid>
                      <Grid>
                        <Typography variant="h6">We're saving your assessment</Typography>
                      </Grid>
                    </Grid>
                  </Backdrop>
                )}
              </Box>
            )}

          <WidgetFooter />
        </WidgetContent>
      )}

      {showAssessmentDialog != null && (
        <AssessmentWizardDialog
          open={showAssessmentDialog != null}
          lockAssessmentOmniType={onboardingAssessmentType}
          autoStartAssessment={true}
          dialogTitle={dialogTitle}
          onClose={() => {
            setShowAssessmentDialog(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  onboardingODM: state.onboardingSession.onboardingODM,
  organizationODM: state.onboardingSession.organizationODM,
  onboardingStatus: state.onboardingSession.onboardingStatus,
  onboardingSuccess: state.onboardingSession.onboardingSuccess,
  onboardingAssessmentType: state.onboardingSession.onboardingAssessmentType,
  inviteKey: state.onboardingSession.inviteKey,
  assessmentODM: state.onboardingSession.assessmentODM,
  onboardingProctorODM: state.onboardingSession.onboardingProctorODM,
  onboardingSubjectODM: state.onboardingSession.onboardingSubjectODM,
  userODM: state.userSession.userODM,
});

const mapDispatchToProps = {
  onboardUserRequest: OnboardingSessionActions.onboardUserRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserOnboardAssessment));
